import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AssigTripsService } from '../../assigntrips-service/assigntrips-service';
import * as _ from 'underscore';

@Component({
  selector: 'app-planner-template-save-modal',
  templateUrl: './planner-template-save-modal.component.html',
  styleUrls: ['./planner-template-save-modal.component.css']
})
export class PlannerTemplateSaveModalComponent implements OnInit {
  @Input() data;
  @Output() close = new EventEmitter();
  template = [];
  title = '';
  idsTemplate = [];
  

  constructor(
    private assignTripService: AssigTripsService
  ) { }

  ngOnInit() {
    this.processBucket();
  }

  processBucket() {
    this.template = this.data;
    this.template.forEach(t => {
      this.idsTemplate.push({
        driver: t.driver._id,
        members: t.members.map(m => m._id)
      })
    });
  }

  saveTemplate() {
    if (!this.title) return;
    const payload = {
      title: this.title,
      mappers: this.idsTemplate
    }

    this.assignTripService
      .addPlannerTemplate(payload)
      .subscribe(data => {
        if (data) {
          this.close.emit();
        }
      });
  }

  closeModal() {
    this.close.emit();
  }

}
